import Vue from 'vue'
import ClickOutside from './click-outside'
import WebpBackground from './webp-background'

Vue.directive('click-outside', ClickOutside)
Vue.directive('webp-background', WebpBackground)
